/* eslint-disable import/first */
import React from 'react';

export default function NoLocationPin(props) {
  return (
    <svg width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.67 16.1196C11.0832 16.1196 10.6081 16.6086 10.6081 17.1954C10.6081 17.7682 11.0692 18.2712 11.67 18.2712C12.2707 18.2712 12.7457 17.7682 12.7457 17.1954C12.7457 16.6086 12.2567 16.1196 11.67 16.1196Z"
        fill="#393F52"
      />
      <path
        d="M11.851 7.97412C9.96486 7.97412 9.09866 9.09187 9.09866 9.84629C9.09866 10.3912 9.55971 10.6427 9.93692 10.6427C10.6914 10.6427 10.384 9.56684 11.8091 9.56684C12.5076 9.56684 13.0665 9.87423 13.0665 10.5169C13.0665 11.2713 12.2841 11.7044 11.8231 12.0956C11.4179 12.4449 10.887 13.0177 10.887 14.2193C10.887 14.9457 11.0826 15.1553 11.6554 15.1553C12.34 15.1553 12.4797 14.848 12.4797 14.5825C12.4797 13.856 12.4937 13.4368 13.2621 12.8361C13.6393 12.5427 14.8268 11.5926 14.8268 10.2793C14.8268 8.96607 13.6393 7.97412 11.851 7.97412Z"
        fill="#393F52"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6718 26.7849L3.76779 19.9153C-0.755956 15.414 -0.755927 8.11597 3.76786 3.61471C8.29164 -0.886545 15.6261 -0.886545 20.1499 3.61471C24.6737 8.11597 24.6737 15.414 20.15 19.9153L13.246 26.7849V30.713C13.246 31.4239 12.6697 32.0001 11.9589 32.0001C11.248 32.0001 10.6718 31.4239 10.6718 30.713V26.7849ZM18.33 18.1043C21.8483 14.6032 21.8481 8.92717 18.3296 5.42632C14.8111 1.92546 9.10666 1.92546 5.58818 5.42632C2.0697 8.92717 2.06951 14.6032 5.58775 18.1043L11.9589 24.4438L18.33 18.1043Z"
        fill="#393F52"
      />
    </svg>
  );
}
